module.exports = __webpack_public_path__ + "static/retail-content-image-1_new-252ed3b6c72c56888258f8ec4e66aabc.jpg";